import React from 'react'
import Select from 'react-select'
import {Consumer} from '../../context'

export default function SelectLanguage(props) {
  return (<Consumer>{ context => {
    return (
      <div className="select-language">
        <div className="dropdown">
          <Select
            className="select-language"
            classNamePrefix="select-language"
            formatOptionLabel = {({name}) => name}
            isSearchable = {false}
            getOptionValue = {({id}) => id}
            value = {context.language}
            onChange = {({id: languageId}) => context.navigate({languageId}, context.match.path, {preserveQuery: true})}
            options = {context.languages}
          />
        </div>
      </div>
    )
  }}</Consumer>)
}
